/**
 * Cooldown-elapsed prompt dismissal key (free-tier subject swap surface).
 *
 * Per-(student, cooldown cycle). Cycle identity = the student's last
 * pick-changing timestamp (`picked_at` = `Student.free_subject_codes_
 * updated_at`). The timestamp moves forward on a real swap → key changes
 * → the prompt re-fires next cycle. Add-only saves DON'T move it (backend
 * rule, subjects.ts) so a student who tops up under-cap isn't re-prompted
 * mid-cooldown.
 *
 * Shared between SubjectSelectPage and ProfilePage so dismissing on either
 * page silences both for that cycle.
 */
export function cooldownPromptDismissalKey(
  studentId: string,
  pickedAt: string | null,
): string {
  return `cooldown_elapsed_prompt_seen_${studentId}_${pickedAt ?? 'never'}`
}
